module.exports = __webpack_public_path__ + "img/05.a5295fc2.jpg";